<template>
  <div class="app">
    <Loading :value="loading"></Loading>
    <v-card>
      <v-card-title>
        <v-breadcrumbs icons divider="chevron_right">
          <v-breadcrumbs-item
            icons
            router
            :to="item.path"
            v-for="item in racourcis"
            :key="item.text"
            :disabled="item.disabled"
          >
            {{ item.text }}</v-breadcrumbs-item
          >
        </v-breadcrumbs>
      </v-card-title>
    </v-card>
    <br />

    <!--Ligne 1 -->
    <v-layout row>
      <v-card style="width:100%">
        <v-card-text fluid grid-list-md>
          <h2>LISTE DES BONS DE COMMANDE INTERNES (BCI)</h2>
          <v-divider class="mb-3"></v-divider>
          <v-layout row>
            <v-layout row class="mb-3 mt-1">
              <v-flex md4 class="mr-1">
                <el-select
                  clearable
                  filterable
                  v-on:change="loadChantier();filtreByProjet(projetS)"
                  v-model="projetS"
                  placeholder="Selectionner de Projet"
                  style="width:100%"
                >
                  <el-option
                    v-for="item in listeProjet"
                    :key="item.id"
                    :label="item.libelle"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </v-flex>
              <v-flex md4 class="mr-1">
                <el-select
                  clearable
                  filterable
                  v-on:change="loadTravaux()"
                  v-model="chantierS"
                  placeholder="Selectionner un Chantier"
                  style="width:100%"
                >
                  <el-option
                    v-for="item in listeChantier"
                    :key="item.id"
                    :label="item.libelle"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </v-flex>
              <v-flex md4 class="mr-1">
                <el-select
                @clear="clearSelect()"
                  clearable
                  filterable
                  @change="filtrerTravaux(travauxS)"
                  v-model="travauxS"
                  placeholder="Selectionner un travaux"
                  style="width:100%"
                >
                  <el-option
                    v-for="item in listeTravaux"
                    :key="item.id"
                    :label="item.libelle"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </v-flex>
              
            </v-layout>
          </v-layout>
          <div class="text-xs-right mb-3">
            <v-tooltip bottom>
                <v-btn class="elevation-3" slot="activator" @click="loadBonCommande()" dark icon flat color="primary">
                    <v-icon>cached</v-icon>
                </v-btn>
                actualiser la liste
            </v-tooltip>

            <v-tooltip>
              <v-btn
                slot="activator"
                color="orange"
                @click.stop="imprimerCommande1()"
                dark
              >
                Imprimer
                <v-icon right>print</v-icon></v-btn>
              Imprimer la liste des bons de commandes internes
            </v-tooltip>
          </div>

          <data-tables
            tables
            mt-3
            ml-1
            mr-1
            ref="multipleTableBon"
            @selection-change="handleSelectionBonChange"
            :data="listBonCommande"
            style="width:100%;"
            :default-sort="{
              prop: 'libelle',
              order: 'descending'
            }"
          >
            <el-table-column
              :selectable="besoinBonSelect"
              width="55"
              type="selection"
            ></el-table-column>
            <el-table-column prop="libelle" label="Libellé" width="280">
              <template slot-scope="scope">
                <v-chip outline text-color="primary" label color="primary"
                  >{{ scope.row.libelle }}
                </v-chip>
              </template>
            </el-table-column>
            <el-table-column
              prop="projet"
              label="Projet"
              width="300"
            >
            </el-table-column>

            <el-table-column
              prop="chantier"
              label="Chantier"
              width="300"
            >
            </el-table-column>

            <el-table-column
              prop="travaux"
              label="Travaux"
              width="300"
            >
            </el-table-column>           
            <el-table-column
              prop="tache"
              label="Tâche"
              width="300"
            >
            <template slot-scope="scope">
              <span v-for="(item, index) in scope.row.tache" :key="index">
                  {{ item }}/
                </span>                         
            </template>
            </el-table-column>

            <el-table-column
              prop="tranconA"
              label="PK debut"
              width="300"
            ></el-table-column>

            <el-table-column
              prop="tranconB"
              label="PK fin"
              width="300"
            ></el-table-column>

            <el-table-column
              prop="dateLivr"
              label="Date livraison souhaitée"
              width="200"
            >
              <template slot-scope="scope">
                <v-chip text-color="white" label color="primary">
                  {{ scope.row.dateLivr }}
                </v-chip>
              </template>
            </el-table-column>
            <el-table-column prop="user" label="Emis par" width="200">
              <template slot-scope="scope">
                <v-chip text-color="white" label color="primary">
                  {{ scope.row.user }}
                </v-chip>
              </template>
            </el-table-column>
            <el-table-column
                prop="niveau"
                label="Niveau de validation"
                width="200"
              >
              <template slot-scope="scope">
                  <v-chip
                    text-color="white"
                    label
                    fab
                    color="green accent-3"
                    v-if="scope.row.niveauValid === 0"
                    >VALIDÉ</v-chip
                  >
                  <v-chip
                    text-color="white"
                    label
                    fab
                    color="orange accent-4"
                    v-else-if="
                      scope.row.niveauValid === 1
                    "
                    >CHEF PROJET</v-chip
                  >
                  <v-chip
                    text-color="white"
                    label
                    fab
                    color="orange accent-3"
                    v-else-if="
                      scope.row.niveauValid === 2
                    "
                    >DEX</v-chip
                  >
                  <v-chip
                    text-color="white"
                    label
                    fab
                    color="blue accent-3"
                    v-else-if="
                      scope.row.niveauValid === 3
                    "
                    >DGA/DOT</v-chip
                  >
                  <v-chip
                    text-color="white"
                    label
                    fab
                    color="yellow accent-3"
                    v-else-if="
                      scope.row.niveauValid === 6
                    "
                    >RESPONSABLE ENTREPOT</v-chip
                  >
                  <v-chip
                    text-color="white"
                    label
                    fab
                    color="red lighten-4"
                    v-else
                    >REJETÉE</v-chip
                  >
                </template>
              </el-table-column>             
            <el-table-column label="Action" fixed="right" width="100">
              <template slot-scope="scope">
                <div class="text-xs-center">
                  <v-tooltip top>
                    <v-btn
                      slot="activator"
                      @click.stop="showCommande(scope.row, true)"
                      fab
                      dark
                      small
                      color="green"
                    >
                      <v-icon dark>folder_open</v-icon> </v-btn
                    >Détails
                  </v-tooltip>
                  <v-tooltip top>
                    <v-btn
                      slot="activator"
                      @click.stop="imprimerCommande(scope.row)"
                      fab
                      dark
                      small
                      color="orange"
                    >
                      <v-icon dark>print</v-icon>
                    </v-btn>
                    Imprimer
                  </v-tooltip>
                  <!-- <v-tooltip top>
                    <v-btn
                      slot="activator"
                      v-show="scope.row.valid === 3"
                      @click.stop="
                        dialogCOmmande = true;
                        idCommande = scope.row;
                      "
                      fab
                      dark
                      small
                      color="red"
                    >
                      <v-icon dark>delete</v-icon> </v-btn
                    >Supprimer
                  </v-tooltip>
                  <v-tooltip top v-if="scope.row.niveauValid === 2">
                    <v-btn
                      slot="activator"
                      @click="molalValidation(scope.row,'OUI','validateur1')"
                      fab
                      dark
                      small
                      color="green"
                    >
                      <v-icon dark>done_all</v-icon>
                    </v-btn>Valider...
                  </v-tooltip>
                  <v-tooltip top v-if="scope.row.niveauValid === 3">
                    <v-btn
                      slot="activator"
                      @click="molalValidation(scope.row, 'OUI','validateur2')"
                      fab
                      dark
                      small
                      color="green"
                    >
                      <v-icon dark>done_all</v-icon>
                    </v-btn>Valider...
                  </v-tooltip>
                  <v-tooltip top v-if="scope.row.niveauValid === 2">
                    <v-btn
                      slot="activator"
                      @click="molalValidation(scope.row, 'NON', 'validateur1')"
                      fab
                      dark
                      small
                      color="red"
                    >
                      <v-icon dark>close</v-icon>
                    </v-btn>Rejeter...
                  </v-tooltip>
                  <v-tooltip top v-if="scope.row.niveauValid  == 3 ">
                    <v-btn
                      slot="activator"
                      @click="molalValidation(scope.row, 'NON', 'validateur2')"
                      fab
                      dark
                      small
                      color="red"
                    >
                      <v-icon dark>close</v-icon>
                    </v-btn>Rejeter...
                  </v-tooltip> -->
                </div>
              </template>
            </el-table-column>
          </data-tables>
        </v-card-text>
      </v-card>
    </v-layout>

    
      <v-dialog v-model="dialogImprCommande" max-width="50%" :overlay="true" scrollable persistent>
          <v-card>
            <v-card-text text-xs-center>
               <p align="center">
                  <v-btn @click.stop="imprimerModeCommande(2)" color="green" dark>
                    Paysage
                    <v-icon right>print</v-icon>
                  </v-btn>
                  <v-btn icons color="orange" @click.stop="imprimerModeCommande(1)" dark>
                    Portrait
                    <v-icon right>print</v-icon>
                  </v-btn>
                </p>
            </v-card-text>
            <div style="flex: 1 1 auto;"></div>
          </v-card>
          <v-btn icon @click.native="dialogImprCommande = false" dark class="blue"
            ><v-icon>close</v-icon>
          </v-btn>
        </v-dialog>

        <v-dialog v-model="dialogImprCommande1" max-width="50%" :overlay="true" scrollable persistent>
          <v-card>
            <v-card-text text-xs-center>
               <p align="center">
                  <v-btn @click.stop="imprimerModeCommande1(2)" color="green" dark>
                    Paysage
                    <v-icon right>print</v-icon>
                  </v-btn>
                  <v-btn icons color="orange" @click.stop="imprimerModeCommande1(1)" dark>
                    Portrait
                    <v-icon right>print</v-icon>
                  </v-btn>
                </p>
            </v-card-text>
            <div style="flex: 1 1 auto;"></div>
          </v-card>
          <v-btn icon @click.native="dialogImprCommande1 = false" dark class="blue"
            ><v-icon>close</v-icon>
          </v-btn>
        </v-dialog>

         <!--  MODAL ACCORD VALIDATION MISSION 2 -->
         <v-dialog v-model="dialogAccord2"  width="40%">
            <v-card>
                <v-card-title class="headline">Voulez-vous valider ce bon de commande ?</v-card-title>
                <!-- <v-card-text>En cliquant sur valider, en tant que responsable, vous donnez votre accord pour </v-card-text> -->
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="green darken-1" flat="flat" @click.native="dialogAccord2 = false">Annuler</v-btn>
                    <v-btn color="green darken-1" flat="flat" @click.native="validRejetBesoin(1)">Valider</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--  MODAL ACCORD VALIDATION MISSION 2-->

        <!-- MODAL CONFIRMATION REFUS-->
        <v-dialog v-model="dialogRejeterMission" width="40%" :overlay="true" scrollable persistent>
            <v-card>
                <v-card-title class="text-xs-center">
                    <h3 class="headline mb-0">Rejeter le bon de commande</h3>
                    <v-flex xs12>
                        <v-alert outline color="orange darken-1" icon="warning" :value="true">
                            Etes-vous sur de vouloir rejeter le bon de commande ?
                        </v-alert>
                    </v-flex>
                </v-card-title>

                <v-card-text>
                    <el-form  class="demo-form-inline">
                        <el-row  :gutter="20">
                            <el-form-item label="Motif du refus">
                                <el-input
                                        type="textarea"
                                        placeholder="Motif du refus"
                                        v-model="commDec">
                                </el-input>
                            </el-form-item>
                        </el-row>
                    </el-form>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click.stop="dialogRejeterMission = false">Annuler</v-btn>
                    <v-btn icons color="red" @click.stop="validRejetBesoin(0)" dark>Confirmer
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- FIN MODAL CONFIRMATION REFUS-->

        <!-- Detail de la commande -->
    <ModalCommandeDetails
      :detailCommande="detailCommande"
      :hiddenButton = "hiddenButton"
      :show="showModalDetailCom"
      @close="showModalDetailCom = false"
    ></ModalCommandeDetails>
    <!-- Detail de la commande -->


    <CoolLightBox :items="items" :index="index" @close="index = null">
        </CoolLightBox>

  </div>
</template>

<script>
import Loading from "@/components/Loading";
import ModalCommandeDetails from "@/components/besoin/ModalCommandeDetails";
import ModalCommandeMAJ from "@/components/besoin/ModalCommandeMAJ";
import ModalComparateurCmd from "@/components/comparateur/ModalComparateurCmd";

export default {
  components: {
    Loading,
    ModalCommandeDetails,
    ModalCommandeMAJ,
    ModalComparateurCmd
  },
  name: "Besoin",
  data() {
    return {
      notif: JSON.parse(sessionStorage.getItem("sessionNotif")),
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
      droitAcces: JSON.parse(sessionStorage.getItem("sessionDroit")),
      loading: false,
      valid: true,
      factNull: false,
      choix: true,
      racourcis: [
        { path: "/", text: "Accueil", disabled: false },
        { path: "/projet", text: "Liste des besoins", disabled: true }
      ],
      priorites: [
        {
          value: 1,
          label: "Faible"
        },
        {
          value: 2,
          label: "Normal"
        },
        {
          value: 3,
          label: "Urgent"
        }
      ],
      EtatConfirmation: [
        {
          value: 0,
          label: "Approuvé"
        },
        {
          value: 1,
          label: "En attente"
        }
      ],
      hiddenButton: false,
      notification: 0,
      notifCommande: 0,
      showModalDetailCom: false,
      selectEtatPrioriteBesoin: null,
      selectEtatConfirmationBesoin: null,
      oldComboUser: [],
      selectEtatService: null,
      comboService: [],
      idBesoin: "",
      idCommande: "",
      commDec:'',
      dialogSupr: false,
      dialogImprCommande: false,
      dialogImprCommande1: false,
      dialogCOmmande: false,
      disabledBtnValide: true,
      dialogBesoin: false,
      dialogComm: false,
      dialogEdit: false,
      listBesoin: [],
      dialogAccord: false,
      dialogAccord2: false,
      dialogValidMission: false,
      dialogRejeterMission: false,
      dialogShowEditRessource: false,
      tacheSelectioner: [],
      commCourant: [],
      items: [],
      index: null,
       formEditRessource: {
        id:'',
        libelle:'',
        qte:0,
        dateF:'',
        dateD:''
      },
      etat: 0,
      selectBci:'',
      selectValidateur: '',
      nombreSelection: 0,
      nombreBonSelection: 0,
      optionBesoin: [
        { type: "", key: 1, value: "", qte: 1, unite: "", id: "", priorite: 1 }
      ],
      optionProduit: [
        { type: "", key: 1, produit: "", qte: 1, unite: "", priorite: "" }
      ],
      listProd: [],
      libelle: "",
      dateLivr: "",
      priorite: 1,
      besoinCourant: [],
      listeProduitAffich: [],
      listeVehicule: [],
      infOrenseigner: [{
        libelle: '',
        dateLivr: '',
        priorite: '',
      }],
      optionCommande: [
        {
          key: 1,
          produit: "",
          codeGestion: "",
          prix: 0,
          qte: 1,
          tva: 0,
          total: 0,
          id: "",
          priorite: 1
        }
      ],
      totalComTTC: 0,
      totComLigneTTCFormat: 0,
      totalComHT: 0,
      totalComTVA: 0,
      totComLigneTTC: 0,
      listFour: [],
      formInventaire: {},
      tableInventaire: [],
      selectFourn: "",
      listCommande: [],
      detailCommande: null,
      
      //filtre
      oldListBesoin: [],
      produitUnite: "",
      listBesoinAttente: [],
      tab: "",

      // POUR BON 
      listBonCommande: [],
      oldListBonCommande: [],
      notifBonCommande: [],
      oldListBonCommande: [],
      

      selectEtatDemandeur: null,
      selectEtatDate: null,

      comboUser: [],
      dateCreated: "",
      typeProduit: "",
      oldListCommande: [],
      selectEtatPrioriteCommande: null,
      selectEtatDateCommande: null,
      activDerouler: false,
      disabledImprime: true,
      showModalModifCom: false,
      listTypeRessource: [],

      //Projet
      listeProjet: [],
      listeChantier: [],
      listeTravaux: [],
      listeTacheTrx: [],

      temp: [],
      projetS: "",
      chantierS: "",
      travauxS: "",
      tacheS: "",
      valeurUniteMateriel: "",
      commandeDeriv: [],
      commandeDerivDeux: [],
      showModalCompCmd: false,
      dialogDetailCmd: false,
      mntTotalCmd: "",
      nbCommandeSug: 0,
      nbCommandeSugDeux: 0,
      typeDmd: "Projet",
      listDemande: [],
      selectDemande: "",

      //Passez une commande
      disabledChamp: false,

      dateLivrSouh: null,

      //details de commande
      idTravaux:'',
      projetLib: "",
      chantieretLib: "",
      entrepotLib: '',
      travuxLib: ""
    };
  },

  methods: {
    //recherche le prix fournisseur pour les produits selection
    handleChangeFour(idFour) {
      let url = this.domaine + "fournisseur/info/produit";
      this.loading = true
      let data = new FormData();

      let produits = new Array();
      let i;
      for (i = 0; i < this.optionCommande.length; i++) {
        produits[i] = this.optionCommande[i].idProd;
      }

      data.append("produits", produits);
      data.append("fournisseur", idFour);

      this.$http.post(url, data).then(
        response => {
          let produits = response.body.produits;
          this.loading = false
          this.optionCommande.forEach((item, index, array, $this) => {
            let $idProd = item.idProd;
            let produitFind = produits.find(prod => {
              return prod.id == $idProd;
            });

            array[index].prix = produitFind.prix;
          });
        },
        error => {
          this.loading = false
        }
      );
    },

    showDiapo(images, ind, image) {
        this.items = images;
        this.index = ind;
      },

      molalValidation(row, etat, validateur) {
        if(etat == 'OUI') {
          this.dialogAccord2 = true
        }else {
          this.dialogRejeterMission = true
        }        
        this.selectBci = row.id
        this.selectValidateur = validateur
      },
    //afficher le formulaire d'une commande
    showFormCommande() {
      //on determine le nombre de produit corespondant
      let comp = 0;
      let temp = [];
      this.factNull = false;
      this.optionCommande.splice(0);
      for (let index = 0; index < this.multipleSelection.length; index++) {
        let element1 = this.multipleSelection[0]["travauxId"];
        // let element2 = this.multipleSelection[0]["idProd"];
        let magasin1 = this.multipleSelection[0]["entrepotId"];
        const element = this.multipleSelection[index]["travauxId"];
        const element2 = this.multipleSelection[index]["entrepotId"];

        if(element1 !=''){
            if (element1 == element) {
              comp++;
            } else {
            this.factNull = true;
            // this.$refs.multipleTable.toggleRowSelection(
            //   this.multipleSelection[index]
            // );
          }
        }else{
          if (magasin1 == element2) {
              comp++;
            } else {
            this.factNull = true;
            this.$refs.multipleTable.toggleRowSelection(
              this.multipleSelection[index]
            );
          }
        }



      }
      if (this.multipleSelection.length == comp && this.factNull === false) {
        let multipleSelection1 = this.multipleSelection

        var tableau = multipleSelection1;
        for (var i = 0; i < tableau.length; ++i) {
          for (var j = i + 1; j < tableau.length; ++j) {
            if (tableau[i].idProd === tableau[j].idProd) {
              tableau[i].qte = tableau[i].qte + tableau[j].qte;
              tableau.splice(j--, 1);
            }
          }
        }
        this.optionCommande = tableau;
        // this.dateLivr = th/
        this.idTravaux = this.multipleSelection[0]['idTravaux']
        this.projetLib = this.multipleSelection[0]["projet"];
        this.dateLivr = this.multipleSelection[0]["dateLivr"];
        this.chantieretLib = this.multipleSelection[0]["chantier"];
        this.entrepotLib = this.multipleSelection[0]["libEntrepot"];
        this.travuxLib = this.multipleSelection[0]["travaux"];
        this.libelle = this.multipleSelection[0]["libelle"] ? this.multipleSelection[0]["libelle"] :'';
        this.hiddenButton = this.libelle != '' ? true : false

        this.selectFourn=''
        this.dialogComm = true;
        this.disabledChamp = false;
      } else {
        this.$notify({
            title: "Fusion",
            message: "Impossible de lier ces besoins pour la commande. Veuillez selectionner des besoins émit pour les mêmes Travaux / pour les mêmes entrepots",
            type: "error",
            position: "top-center"
          });
      }
    },
    besoinBonSelect(row, index) {
      let etat = null;
      if (parseFloat(row.qte) != 0) {
        etat = true;
      } else {
        etat = false;
      }
      return etat;
    },
    showForGenererCommande() {
      //on determine le nombre de produit corespondant
      let comp = 0;
      let temp = [];
      this.factNull = false;
      this.optionCommande.splice(0);
      for (let index = 0; index < this.multipleSelection.length; index++) {
        let element1 = this.multipleSelection[0]["travauxId"];
        // let element2 = this.multipleSelection[0]["idProd"];
        let magasin1 = this.multipleSelection[0]["entrepotId"];
        const element = this.multipleSelection[index]["travauxId"];
        const element2 = this.multipleSelection[index]["entrepotId"];

        if(element1 !=''){
            if (element1 == element) {
              comp++;
            } else {
            this.factNull = true;
            // this.$refs.multipleTable.toggleRowSelection(
            //   this.multipleSelection[index]
            // );
          }
        }else{
          if (magasin1 == element2) {
              comp++;
            } else {
            this.factNull = true;
            this.$refs.multipleTable.toggleRowSelection(
              this.multipleSelection[index]
            );
          }
        }



      }

      if (this.multipleSelection.length == comp && this.factNull === false) {
        let multipleSelection1 = this.multipleSelection

        var tableau = multipleSelection1;
        for (var i = 0; i < tableau.length; ++i) {
          for (var j = i + 1; j < tableau.length; ++j) {
            if (tableau[i].idProd === tableau[j].idProd) {
              tableau[i].qte = tableau[i].qte + tableau[j].qte;
              tableau.splice(j--, 1);
            }
          }
        }
        this.optionCommande = tableau;
        // this.dateLivr = th/
        this.idTravaux = this.multipleSelection[0]['idTravaux']
        this.projetLib = this.multipleSelection[0]["projet"];
        this.dateLivr = this.multipleSelection[0]["dateLivr"];
        this.chantieretLib = this.multipleSelection[0]["chantier"];
        this.entrepotLib = this.multipleSelection[0]["libEntrepot"];
        this.travuxLib = this.multipleSelection[0]["travaux"];
        this.libelle = this.multipleSelection[0]["libelle"] ? this.multipleSelection[0]["libelle"] :'';
        this.hiddenButton = this.libelle != '' ? true : false

        this.selectFourn=''
        this.dialogComm = true;
        this.disabledChamp = false;
      } else {
        this.$notify({
            title: "Fusion",
            message: "Impossible de lier ces besoins pour la commande. Veuillez selectionner des besoins émit pour les mêmes Travaux / pour les mêmes entrepots",
            type: "error",
            position: "top-center"
          });
      }
    },


    //afficher le formulaire de generation de commande
    showBunttonGenerer() {
        dump('text');
        die();
      this.hiddenButton = true
      //  recuperation des produits concerne
      this.optionCommande.splice(0);
      this.multipleSelection.forEach(optionbesoin => {
        this.optionCommande.push(optionbesoin);
      }, this);
      this.idTravaux = this.multipleSelection[0]['projet']
      this.projetLib = this.multipleSelection[0]["projet"];
      this.chantieretLib = this.multipleSelection[0]["chantier"];
      this.travuxLib = this.multipleSelection[0]["travaux"];
      this.dateLivr = this.multipleSelection[0]["dateLivrSouh"];
      this.entrepotLib = this.multipleSelection[0]["libEntrepot"];
      this.libelle =''
      this.selectFourn=''
      this.dialogComm = true;
      this.disabledChamp = false;
    },


    //afficher le formulaire d'une commande
    showFormCommandNew() {
      //  recuperation des produits concerne
      this.optionCommande.splice(0);
      
      this.multipleSelection.forEach(optionbesoin => {
        this.optionCommande.push(optionbesoin['option'] ? optionbesoin['option'][0] : optionbesoin);
      }, this);
      this.idTravaux = this.multipleSelection[0]['idTravaux']
      this.projetLib = this.multipleSelection[0]["projet"];
      this.chantieretLib = this.multipleSelection[0]["chantier"];
      this.travuxLib = this.multipleSelection[0]["travaux"];
      this.dateLivr = this.multipleSelection[0]["dateLivr"];
      this.entrepotLib = this.multipleSelection[0]["libEntrepot"];
      this.libelle = this.multipleSelection[0]["libelle"] ? this.multipleSelection[0]["libelle"] :'';
      this.hiddenButton = this.libelle != '' ? false : true

      this.selectFourn=''
      this.dialogComm = true;
      this.disabledChamp = false;
      this.hiddenButton = false;
    },

    //Action methodes
    showCommande(ligneCommande,etat = false) {
      this.hiddenButton = etat
      this.disabledChamp = true;
      this.showModalDetailCom = true;
      this.detailCommande = ligneCommande;
    },

    editCommande(ligneCommande) {
      this.showModalModifCom = true;
      this.detailCommande = ligneCommande;
    },
    deleteCommande() {
      this.loading = true;
      let url = this.domaine + "besoin/delete/comd/" + this.idCommande.id;
      this.$http.get(url).then(response => {
        if (response.body) {
          this.$notify({
            title: "SUPPRESSION",
            message: "Commande supprimé avec succès.",
            type: "success",
            position: "top-center"
          });
          this.dialogCOmmande = false;
          this.dialogSupr = false;
          this.loading = false;
          this.loadCommandeRecent();
        } else {
          this.$message.error("Impossible de supprimer");
          this.loading = false;
        }
      },
      (error) => {
        this.$message.error("Impossible de supprimer");
          this.loading = false;
      });
    },
    //Controlle de l'activation du boutton deroulez
    activationDerouler() {
      this.activDerouler
        ? (this.activDerouler = false)
        : (this.activDerouler = true);
      //enregistrement des besoins ayant été vue par l'utilisateur
      if (this.activDerouler && this.listBesoin.length > 0)
        this.enregistrementBesoinVue();
    },

    enregistrementBesoinVue() {
      let url = this.domaine + "besoin/save/checked/" + this.user.id + "/show";
      this.$http.get(url);
    },
    validRejetBesoin(decision) {
        this.loading = true;  
        //decision == 1 = Valider // decision == 0 //Refuser
        let url = ''
        if( this.selectValidateur == 'validateur1') {
          url= this.domaine + "besoin/avalider/bci/nivau1";
        }else {
          url = this.domaine + "besoin/avalider/bci/nivau2";
        }

        let data = new FormData();        
        data.append("decision", decision);
        data.append("commDec", this.commDec);
        data.append("typeValidateur", this.selectValidateur);
        data.append("idUser", this.user.id);
        data.append("bci", this.selectBci);

        this.$http.post(url, data).then(
          resp => {
            this.dialogValideBesoin = false;
            this.loading = false;
            this.dialogAccord2 = false        
            this.dialogRejeterMission = false        
            this.$emit("reloadBesoins");
            this.$notify({
              title: "Validation besoins",
              message: "L'opération s'est déroulée avec succès",
              type: "success",
              position: "top-center"
            });
          },
          error => {
            this.dialogValideBesoin = false;
            this.loading = false;
            this.$message.error(
              "Erreur lors du chargement de la validation des besoins"
            );
          }
        );

        
      },
    //filtre commande
    clearSelectCommande() {
      this.listCommande = this.oldListCommande;
    },

    filtrerEtatDateCommande(date) {
      this.selectEtatPrioriteCommande = null;

      this.listCommande = this.oldListCommande;
      this.listCommande = this.listCommande.filter(commande => {
        if (commande.dateJour >= date[0] && commande.dateJour <= date[1])
          return commande.dateJour;
        else if (commande.dateJour == date[0] && commande.dateJour == date[1])
          return commande.dateJour;
      });
    },

    filtrerEtatPrioriteCommande(priorite) {
      //reinitialisation de la liste commande
      this.listCommande = this.oldListCommande;
      this.selectEtatDateCommande = null;

      //filtre de la liste de commande
      this.listCommande = this.listCommande.filter(commande => {
        return commande.priorite == priorite;
      });
    },

    loadDemande() {
      this.loading = true;
      this.listDemande = [];
      let url = this.domaine + "entrepot/liste";
      this.$http.get(url).then(response => {
        if (response.body) {
          this.listDemande = response.body.demande;
          this.loading = false;
        }
      });
    },

    loadFourn() {
      this.loading = true;
      let url = this.domaine + "fournisseur/index";
      this.$http.get(url).then(response => {
        if (response.body) {
          this.listFour = response.body.fournisseur;
          this.loading = false;
        }
      });
    },
    loadTravaux() {
      this.loading = true;
      this.travauxS = "";
      this.listTravaux = [];
      if (this.chantierS != "" && this.chantierS != null) {
        let url =
          this.domaine + "projet/" + this.chantierS + "/index/chantier/travaux";
        this.$http.get(url).then(response => {
          if (response.body) {
            this.listeTravaux = response.body.travaux;
            this.loading = false;
          }
        });
      } else {
        this.$message.error("Veuillez sélectionner un chantier");
        this.loading = false;
      }
    },

    loadTacheTrx() {
      this.loading = true;
      this.tacheS = "";
      this.listeTacheTrx.splice(0);
      if (this.travauxS != "" || this.travauxS !== undefined) {
        let url = this.domaine + "tache/travaux/" + this.travauxS;
        this.$http.get(url).then(response => {
          this.listeTacheTrx = response.body.taches;
          this.loading = false;
        });
      } else {
        this.$message.error("Veuillez sélectionner une tache");
        this.loading = false;
      }
    },

    //filtre
    loadDemandeur(userId) {
      this.selectEtatDate = null;
      this.listBesoin = this.oldListBesoin;
      this.listBesoin = this.listBesoin.filter(function(item) {
        return item.userId == userId;
      });
    },

    loadDate(date) {
      this.listBesoin = this.oldListBesoin;
      this.selectEtatDemandeur = null;
      if(date) {
          this.listBesoin = this.listBesoin.filter(item => {
          if (item.dateJour >= date[0] && item.dateJour <= date[1])
            return item.dateJour;
          else if (item.dateJour == date[0] || item.dateJour == date[1])
            return item.dateJour;
        });
      }    
    },

    loadServiceBesoin(service) {
      this.listBesoin = this.oldListBesoin;
      this.selectEtatDate = null;
      this.listBesoin = this.listBesoin.filter(besoin => {
        this.comboUser = this.oldComboUser;
        this.comboUser = this.comboUser.filter(user => {
          return user.serviceId == service;
        });
        return besoin.serviceId == service;
      });
    },

    filtrerEtatPrioriteBesoin(priorite) {
      //reinitialisation de la liste commande
      this.listBesoin = this.oldListBesoin;
      this.selectEtatDate = null;
      this.selectEtatService = null;
      this.selectEtatDemandeur = null;

      //filtre de la liste de commande
      this.listBesoin = this.listBesoin.filter(besoin => {
        return besoin.priorite == priorite;
      });
    },
    filtrerEtatConfirmationBesoin(etat) {
      //reinitialisation de la liste commande
      this.listBesoin = this.oldListBesoin;
      this.selectEtatDate = null;
      this.selectEtatService = null;
      this.selectEtatDemandeur = null;

      // filtre de la liste de commande
      this.listBesoin = this.listBesoin.filter(besoin => {
        return besoin.etat == etat;
      });
    },

    filtrerEtatService(service) {
      this.loadServiceBesoin(service);
    },

    filtrerEtatDemandeur(userId) {
      this.loadDemandeur(userId);
    },

    filtrerEtatDate(date) {
      if (this.selectEtatDate != null) this.loadDate(date);
      else this.listBesoin = this.oldListBesoin;
    },
    filtrerEntrepot(idEnt) {
      this.loadDmdParEntrp(idEnt);
    },
    filtrerCmdEntrepot(idEnt) {
      this.loadCmdParEntrp(idEnt);
    },
    filtrerTravaux(travauxS) {
      this.loadDmdParTrx(travauxS);
    },
    filtrerCommandeTravaux(travauxS) {
      this.loadCmdParTrx(travauxS);
    },
  filtreByChantier(idChantier) {
    this.listBesoin = this.oldListBesoin;
    if(idChantier == '' || idChantier == null) {
     this.listBesoin = this.oldListBesoin;
    }  
    this.listBesoin = this.listBesoin.filter(function(item) {
      return item.chantierId == idChantier;
    });
  },
  filtreByProjet(idProjet) {    
    this.listBesoin = this.oldListBesoin;
    if(idProjet == '' || idProjet == null) {
     this.listBesoin = this.oldListBesoin;
    }  
    this.listBesoin = this.listBesoin.filter(function(item) {
      return item.projetId == idProjet;
    });
  },
    loadCmdParTrx(travauxS) {
      this.listCommande = this.oldListCommande;
      this.listCommande = this.listCommande.filter(function(item) {
        return item.travauxId == travauxS;
      });
    },

    loadDmdParTrx(travauxS) {
      this.listBesoin = this.oldListBonCommande;
      //this.selectEtatDmd = null;
      this.listBonCommande = this.listBesoin.filter(function(item) {
        return item.travauxId == travauxS;
      });

    },

    loadDmdParEntrp(idEnt) {
      this.listBesoin = this.oldListBonCommande;
      //this.selectEtatDmd = null;
      this.listBesoin = this.listBesoin.filter(function(item) {
        return item.entrepotId == idEnt;
      });

    },

    loadCmdParEntrp(idEnt) {
      this.listCommande = this.oldListCommande;
      this.listCommande = this.listCommande.filter(function(item) {
        return item.entrepotId == idEnt;
      });
    },
    verifFormInfo(optionP) {
      if (optionP.unite != null) {
        return true;
      } else {
        return false;
      }
    },

    clearSelect() {
      this.listBonCommande = this.oldListBonCommande;
      this.comboUser = this.oldComboUser;
    },
     editRessources(ligne) {
      this.dialogShowEditRessource = true
      this.tacheSelectioner = ligne;
      this.formEditRessource.libelle = ligne.produit
      this.formEditRessource.qte = ligne.qte
      this.formEditRessource.dateD = ligne.dateDUtilisation
      this.formEditRessource.dateF = ligne.dateFUtilisation
    },
    resetFormEditRess() {
      this.formEditRessource= {}
      this.dialogShowEditRessource = false
    },
    //filtre
    loadUser() {
      this.loading = true;
      let url = this.domaine + "besoin/liste/utilisateur";
      this.$http.get(url).then(response => {
        if (response.body) {
          this.comboUser = Object.values(response.body.user);
          this.oldComboUser = this.comboUser;
          this.loading = false;
        }
      });
    },
    loadTypeRessource() {
      let url =this.domaine + "product/typeRessource";
        this.$http.get(url).then(response => {
          if (response.body) {
            this.listTypeRessource = response.body.types;
            this.loading = false;
          }
        });
      },
    loadService() {
      this.loading = true;
      let url = this.domaine + "besoin/liste/service";
      this.$http.get(url).then(response => {
        if (response.body) {
          this.comboService = Object.values(response.body.service);
          this.loading = false;
        }
      });
    },
    imprimerCommande (ligne) {
        this.dialogImprCommande = true
        this.commCourant = ligne
      },
      imprimerCommande1 () {
        this.dialogImprCommande1 = true
      },
      imprimerModeCommande(mode){
          let url = this.domaine + 'besoin/' + this.commCourant.id + '/imprimer/commande/'+this.user.id+'/'+mode
          this.$http.get(url).then(response => {
              if (response.body) {
              }
          })
          this.dialogImprCommande = false
          window.open(url)
      },
      imprimerModeCommande1(mode){
          let url = this.domaine +  'besoin/' + "imprimer/liste/bci/"+this.user.id+'/'+mode
          this.$http.get(url).then(response => {
              if (response.body) {
              }
          })
          this.dialogImprCommande = false
          window.open(url)
      },
    //Imprimer la liste des besoins
    imprimeListeBesoin(type) {
      let url = "";
      if (type == "PDF") {
          url = this.domaine + "besoin/imprimerPDF/liste";
        } else {
          url = this.domaine + "besoin/imprimerEXC/liste";
        }

      this.$http.get(url).then(response => {
          if (response.body) {
          }
      })
      window.open(url)
    },
    deleteRow(index, rows) {
      rows.splice(index, 1);
    },
    //Suppression
    deleteNeed() {
      var besoinId = this.recupIdSelection();

      this.$confirm("Voulez-vous supprimer cette selection?", "Attention", {
        confirmButtonText: "Oui",
        cancelButtonText: "Non",
        type: "warning"
      })
        .then(() => {
          this.$message({
            type: "success",
            message: "Suppression en cours!"
          });
          this.loading = true;
          let besoinTabId = [];
          let i = 0;

          //envoie du tableau obtenu
          let url = this.domaine + "besoin/delete/selection/" + besoinId;
          this.$http.get(url).then(response => {
            if (response.ok) {
              this.loading = false;
              this.$notify({
                title: "SUPPRESSION REUSSIE",
                message: "La selection a été supprimée avec succès.",
                type: "success",
                position: "top-center"
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Suppression annulée"
          });
        });
    },

    recupIdSelection() {
      let besoinTabId = [];
      this.multipleSelection.forEach(besoin => {
        besoinTabId.push(besoin.id);
      });
      return besoinTabId;
    },

    loadPage() {
      this.loading = true;
    },

    loadBonCommande() {
      this.loading = true;
      let url = this.domaine + "besoin/index/boncommande/0/recent";
      this.$http.get(url).then(response => {
        if (response.body) {
          this.listBonCommande = Object.values(response.body.besoin);         
          this.oldListBonCommande = this.listBonCommande;
          this.notifBonCommande = this.listBonCommande.length
          this.loading = false;
        }
      });
    },
    submitComm() {
      const dateNow = new Date().toISOString().slice(0, 10);

      // on change le format de la date pour  la comparaison  de date
      let tabDateDbt = this.dateLivr.split("-"); //["16","08","2018 00:00:00"]
        let jr = tabDateDbt[0];
        let mois = tabDateDbt[1];
        let annee = tabDateDbt[2].split(" ")[0];
        let dateDbt = annee + "-" + mois + "-" + jr;
      this.loading = true;
      if (
        this.$refs.formComm.validate() &&
        this.libelle != "" &&
        this.dateLivr != "" &&
        // this.selectFourn != "" &&
        dateNow <= dateDbt
      ) {
        let etat = false;
        if (this.optionCommande.length > 0) {
          this.optionCommande.forEach(function(item) {
            if (
              item.produit != "" &&
              item.prix > 0 &&
              item.qte > 0 &&
              item.unite != "" &&
              item.priorite > 0
            ) {
              etat = true;
            }
          });
        }

        if (etat == true  ||  this.hiddenButton == true) {
          var form = document.getElementById("formComm");
          let data = new FormData();
          let url=''
          data.append("libelle", this.libelle);
          data.append("dateLivr", this.dateLivr);
          data.append("priorite", this.priorite);
          data.append("total", this.totalComTTC);
          data.append("idUser", this.user.id);
          data.append("fournisseur", this.selectFourn);
          data.append("projetId", this.projetS);
          data.append("chantierId", this.chantierS);
          data.append("bonGenerer", this.hiddenButton);          
          data.append("travauxId", this.multipleSelection[0]["travauxId"]);
          data.append("entrepotId", this.multipleSelection[0]["entrepotId"]);
          //on va enregister dabor la commande
          url = this.domaine + "besoin/commande/new";

           this.$http.post(url, data).then(
                    response => {
                        if (response.body) {
                        let verif = response.body;
                      url = this.domaine + "besoin/new/commande";
                      let nbData = 10;
                      let nbReq = 1;
                      let ligne = null;

                      let nbRest
                      if (this.optionCommande.length > 10) {
                        nbData = 10;
                        nbReq = Math.round(this.optionCommande.length / nbData);
                        nbRest = this.optionCommande.length % nbData;
                        if (nbRest > 0) {
                          nbReq += 1;
                        }
                      }


                      this.totalComTTC = 0;
                      for(let i=0; i<nbReq;i++)
                          {
                              let initJ = i*nbData;
                              let finJ = (i + 1) * nbData;
                              let dataLot = [];
                              if(this.optionCommande.length > 0){
                                  for(let j = initJ;j < finJ;j++){
                                      if(this.optionCommande[j] == undefined){
                                          break ;
                                      }
                                      dataLot.push(this.optionCommande[j]);
                                  }
                              }
                              let data = new FormData();
                              for (let prop in dataLot) {
                                  ligne = dataLot[prop];
                                  data.append("options[id][]", ligne.id);
                                  data.append("options[produit][]", ligne.produit);
                                  data.append("options[prix][]", ligne.prix);
                                  data.append("options[qte][]", ligne.qte);
                                  data.append("options[unite][]", ligne.unite);
                                  data.append("options[tva][]", ligne.tva);
                                  data.append("options[total][]", ligne.total);
                                  this.totalComTTC += ligne.total;
                                }

                            data.append("idCommande", verif.idCommande);
                            data.append("idBonCommande", verif.idBonCommande);
                            data.append("total", this.totalComTTC);
                            data.append("idUser", this.user.id);
                            data.append("fournisseur", this.selectFourn);
                            data.append("projetId", this.projetS);
                            data.append("chantierId", this.chantierS);
                            data.append("travauxId", this.multipleSelection[0]["travauxId"]);

                              this.$http.post(url, data).then(
                                  response => {
                                      if (response.body) {
                                  let verif = response.body;
                                  
                                  if (verif.code === 1) {
                                    this.$notify({
                                      title: "ENREGISTREMENT REUSSI",
                                      message: "Commande enregistrée avec succès.",
                                      type: "success",
                                      position: "top-center"
                                    });

                                    this.dialogComm = false;
                                    this.loadCommandeRecent();
                                    this.loadRecentBesoin();
                                    this.$refs.formComm.reset();
                                  } else if (verif.code === 2) {
                                    this.$message.error(verif.message);
                                    this.loading = false;
                                  } else if (verif.code === 3) {
                                    this.$notify({
                                      title: "ENREGISTREMENT REUSSI",
                                      message: "Bon de commande générer avec succès.",
                                      type: "success",
                                      position: "top-center"
                                    });

                                    this.dialogComm = false;
                                    this.loadCommandeRecent();
                                    this.loadRecentBesoin();
                                    this.loading = false;
                                  }
                                  this.loadBonCommande()
                                } else {
                                  this.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
                                  this.loading = false;
                                  this.clear();
                                  }
                                  },
                                  error => {
                                      this.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
                                    this.loading = false;
                                  }
                              )
                          }
                    }
                },
                error => {
                    this.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
                  this.loading = false;
                }
            )

        } else {
          this.$notify({
            title: "ATTENTION",
            message:
              "Vous devez obligatoirement enregistré des lignes pour la commande et que ces lignes ont été correctements remplis , les prix des produits doivent etre obligatoirement superieur a 0.",
            position: "top-center",
            type: "warning"
          });
          this.loading = false;
        }
      } else {
        this.$message.error(
          "Veuillez renseigner les champs obligatoires ou verifier que la date est superieur de la date d'aujourd'hui"
        );
        this.$notify.error({
          title: "ERREUR D'ENREGISTREMENT",
          message: "La commande n'a pas été enregistré.",
          position: "top-center"
        });
        this.loading = false;
      }
    },
    loadRecentBesoin() {
      this.loading = true;
      let url = "";
      if (this.droitAcces.besoin) {
        url = this.domaine + "besoin/index_recent";
      } else {
        url = this.domaine + "besoin/index/" + this.user.id + "/user/recent";
      }

      this.$http.get(url).then(response => {
        if (response.body) {
          this.listBesoin = response.body.besoin ? response.body.besoin : [];
          this.notification =  this.listBesoin.length
          this.listBesoinAttente = response.body.besoinAttente;
          this.oldListBesoin = response.body.besoin;
          if (this.oldListBesoin) this.disabledImprime = false;
          else this.disabledImprime = true;
          this.loading = false;
        }
      });
      this.loadUser();
      this.loadDate();
      this.loadService();
    },
    loadCommandeRecent() {
      this.loading = true;
      let url = "";
      if (this.droitAcces.index_besoin_commande) {
        url = this.domaine + "besoin/index/commande/recent";
      } else {
        url =
          this.domaine +
          "besoin/index/commande/recent/" +
          this.user.id +
          "/user";
      }
      this.$http.get(url).then(response => {
        if (response.body) {
          this.listCommande = Object.values(response.body.commande);

          this.oldListCommande = this.listCommande;
          this.notifCommande = this.listCommande.length
          this.loading = false;
        }
      });
    },
    handleSelect(produit) {
      let index = this.optionBesoin.indexOf(produit);
      this.optionBesoin.splice(index, 3, produit);
    },
    editBesoin() {
      this.dialogBesoin = true;
      this.dialogEdit = true;
      this.optionBesoin = this.multipleSelection;
    },
    besoinSelect(row, index) {
      let etat = null;
      if (parseFloat(row.qte) != 0) {
        etat = true;
      } else {
        etat = false;
      }
      return etat;
    },
    loadTypeProduit(item) {
      this.loading = true;
      let url = this.domaine + "product/productSelect/type/" + item;
      this.$http.get(url).then(
        response => {
          this.loading = false;
          this.listeProduitAffich = response.body.produits;
        },
        errRep => {
          this.loading = false;
          this.$message.error(
            "Une erreur est survenue lors du chargement de la liste du chntier"
          );
        }
      );
    },

    loadVehicule() {
        this.loading = true
        let url = this.domaine + "product/productSelect/type/" + 'VEHICULE/ENGIN';
        this.$http.get(url).then(
          response => {
            this.loading = false;
            this.listeVehicule = response.body.produits;
          },
          errRep => {
            this.loading = false;
            this.$message.error(
              "Une erreur est survenue lors du chargement de la liste du chntier"
            );
          }
        );
    }, 
    calculTotalBe() {},

    //Notifications
    showNotification() {
      let url = this.domaine + "besoin/affiche/notification/" + this.user.id;

      //recuperation des notifications
      this.$http.get(url).then(response => {
        if (response.body) this.notification = response.body.notification;
      });
    },
    verifPrioriteBonBesoin() {
      let tabPrioriteProd = [];
      let prioriteFinal = 0;
      //Recuperation des priorites des besoins
      this.multipleSelection.forEach(produit => {
        tabPrioriteProd.push(produit.priorite);
      });

      //Verification et des niveaux de priorite
      for (let i = 0; i < tabPrioriteProd.length; i++) {
        if (tabPrioriteProd[i] === 3) {
          prioriteFinal = 3;
          break;
        } else if (tabPrioriteProd[i] === 2) {
          //Control de l'existence d'une priorité plus haute
          for (let i = 0; i < tabPrioriteProd.length; i++) {
            if (tabPrioriteProd[i] === 3) {
              prioriteFinal = 3;
              break;
            } else {
              prioriteFinal = 2;
            }
          }
          break;
        } else {
          prioriteFinal = 1;
        }
      }

      //Attributon de la valeur de la priorite
      this.priorite = prioriteFinal;
    },
    verifPrioriteBesoin() {
      let tabPrioriteProd = [];
      let prioriteFinal = 0;

      //Recuperation des priorites des besoins
      this.multipleSelection.forEach(produit => {
        tabPrioriteProd.push(produit.priorite);
      });

      //Verification et des niveaux de priorite
      for (let i = 0; i < tabPrioriteProd.length; i++) {
        if (tabPrioriteProd[i] === 3) {
          prioriteFinal = 3;
          break;
        } else if (tabPrioriteProd[i] === 2) {
          //Control de l'existence d'une priorité plus haute
          for (let i = 0; i < tabPrioriteProd.length; i++) {
            if (tabPrioriteProd[i] === 3) {
              prioriteFinal = 3;
              break;
            } else {
              prioriteFinal = 2;
            }
          }
          break;
        } else {
          prioriteFinal = 1;
        }
      }

      //Attributon de la valeur de la priorite
      this.priorite = prioriteFinal;
    },
    createFilter(queryString) {
      return link => {
        return (
          link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
        );
      };
    },
    handleSelectionBonChange(val) {
      let factNull = false;
      //verification de l'etat
      let dataFact = val.filter((elt, index) => {
        if (elt.etat == 1) {
          this.$refs.multipleTableBon.toggleRowSelection(elt);
          factNull = true;
        }
        return elt.etat == 1;
      });


      this.nombreBonSelection = val;
      this.multipleSelection = val;
      if (this.nombreBonSelection.length === 0) {
        this.disabledBtnValide = true;
        this.choix = true;
      } else {
        this.disabledBtnValide = false;
        this.choix = false;
      }

      if (factNull == true) {
        this.$message({
          message:
            "Attention, vous ne pouvez selectionner que les besoins deja validé",
          type: "warning",
          duration: 1000
        });
      }    
    },
  
    handleSelectionChange(val) {
      let factNull = false;
      //verification de l'etat
      let dataFact = val.filter((elt, index) => {
        if (elt.etat == 1) {
          this.$refs.multipleTable.toggleRowSelection(elt);
          factNull = true;
        }
        return elt.etat == 1;
      });

      //  this.multipleSelection = dataFact
      this.multipleSelection = val;
      this.nombreSelection = val;
      if (this.multipleSelection.length === 0) {
        this.disabledBtnValide = true;
        this.choix = true;
      } else {
        this.disabledBtnValide = false;
        this.choix = false;
      }

      if (factNull == true) {
        this.$message({
          message:
            "Attention, vous ne pouvez selectionner que les besoins deja validé",
          type: "warning",
          duration: 1000
        });
      }    
    },
    //Projet
    selectProjet(idProjet) {
      this.loadChantier(idProjet);
    },

    loadProjet() {
      let url = this.domaine + "projet/index/projet/all";

      this.loading = true;
      this.$http.get(url).then(
        response => {
          this.loading = false;
          this.listeProjet = response.body.projet;
        },
        errRep => {
          this.loading = false;
          this.$message.error(
            "Une erreur est survenue lors du chargement de la liste des projets"
          );
        }
      );
    },

    loadChantier() {
      if (this.projetS == "" || this.projetS == null) {
        return;
      }
      this.loading = true;
      this.listeChantier.splice(0);
      this.listeTacheTrx.splice(0);
      this.listeTravaux.splice(0);

      (this.chantierS = ""), (this.travauxS = "");
      this.tacheS = "";

      let url = this.domaine + "projet/" + this.projetS + "/index/chantier";
      this.$http.get(url).then(
        response => {
          this.loading = false;
          this.listeChantier = response.body.chantier;
        },
        errRep => {
          this.loading = false;
          this.$message.error(
            "Une erreur est survenue lors du chargement de la liste du chntier"
          );
        }
      );
    },

    loadProduitFoun(ligne) {
      this.loading = true;
      this.fournCourant = ligne;
      let url = "";
      // if (this.droitAcces.index_produit_fourn) {
        url =
          this.domaine +
          "fournisseur/" +
          this.fournCourant.id +
          "/index/produit";
      // } else {
      //   url =
      //     this.domaine +
      //     "fournisseur/" +
      //     this.fournCourant.id +
      //     "/index/" +
      //     this.user.id +
      //     "/produit";
      // }

      this.$http.get(url).then(response => {
        if (response.body) {
          this.listProduit = response.body.produit;
          this.loading = false;
        }
      });
    },
    closeDialogComp() {
      this.showModalDetailCmd = false;
      //this.loadCommande()
      //this.loadBesoin()
    },
    imprimerListe() {
      this.loading = true;
      this.optionCommande = this.multipleSelection;
      let options = [];
      var formdata = new FormData();
       for (let prop in this.optionCommande) {
        let ligne = this.optionCommande[prop];
          options.push(ligne.id);
      }

      let  url = this.domaine + "comparateur/imprimerPDF/listePrixFourn";
      formdata.append("options", options);
      formdata.append("typeOption", 2); //optionBesoin

      let req=new XMLHttpRequest();
      this.$http
        .post(url, formdata, { responseType: "arraybuffer" })
        .then(response => {
          let blob = new Blob([response.data], {
            type: response.headers.get("content-type")
          });

          let url = URL.createObjectURL(blob);
          this.loading = false;
          window.open(url);
        });
    },

    showDialogComparaison() {
      this.loading = true;
      this.dialogComm = false
      this.optionCommande = this.multipleSelection;
      var formdata = new FormData();
      let url = this.domaine + "comparateur/new/commande";
      let options = [];
      let listProdPrixNulle = [];
      let smsAficher =
        "Aucune tarification de ce produit est indiqué chez vous fournisseurs ";
      let mesProdPrixNulle =
        "Les produits de cette commande ne se trouvent chez aucun de vos fournisseurs ";

      for (let prop in this.optionCommande) {
        let ligne = this.optionCommande[prop];
          options.push(ligne.id);
      }
      formdata.append("options", options);
      formdata.append("typeOption", 2); //optionBesoin

      this.$http.post(url, formdata).then(
        response => {
          //affichage des messages
          let nbCmd = 0;
          let nbCmdDeux = 0
          let listeFoun = [];
          let listeNull = [];
          let listeFounSecond = []
          if (response.body.code == 1) {
            var nbProdNull = response.body.listeProdNull.length;
            let messages = response.body.messageProd;
            let mes = "";
            //recuperer les message
            for (var index in messages) {
              mes += "-- " + messages[index];
            }

            this.$confirm(mes, "Avertissement", {
              confirmButtonText: "Continuer",
              cancelButtonText: "Annuler",
              type: "warning"
            })
              .then(() => {
                const respFour = response.body.fournisseurs[0];
                this.mntTotalCmd = response.body.mntTotauxFormat;
                this.listeProdNull = response.body.listeProdNull;

                //let listeFoun = [];
                for (let four in respFour) {
                  nbCmd++;
                  let listeProduit = respFour[four];
                  let infoFour = {
                    fournisseur: four,
                    produits: [],
                    mntTotal: 0,
                    mntTotalHt: 0,
                  };

                  for (let produit of listeProduit) {
                    infoFour.produits.push(produit);
                    infoFour.mntTotal += parseFloat(produit.mntTotal);
                    infoFour.mntTotalHt += parseFloat(produit.mntTotalHt);
                  }
                  listeFoun.push(infoFour);
                }

                this.nbCommandeSug = nbCmd;
                this.commandeDeriv = listeFoun;

                this.dialogDetailCmd = true;
                this.loading = false;

                //AFFICHAGE DE PRODUITS DONT LE MONTANT EST NULL
                if (response.body.listeProdNull.length > 0) {
                  this.dialogProdNull = true;
                  //this.closeProdNull();
                }
                if (listeFoun.length > 0) {
                  this.showModalCompCmd = true;
                }
              })
              .catch(() => {
                this.loading = false
                this.showModalCompCmd = false;
                this.$alert(smsAficher, {
                    confirmButtonText: "OK"
                  });
              });
          } else {
            const respFour = response.body.fournisseurs[0];
            this.mntTotalCmd = response.body.mntTotauxFormat;
            this.listeProdNull = response.body.listeProdNull;
             if (respFour.length == 0) {
                this.loading = false;
                this.$alert(mesProdPrixNulle, "", {
                  confirmButtonText: "OK"
                });
                return
              }
              this.loading = false;
              this.dialogComm = false
              this.showModalCompCmd = false;
            for (let four in respFour) {
              let listeProduit = respFour[four];
              let infoFour = {
                fournisseur: four,
                produits: [],
                mntTotal: 0,
                mntTotalHt: 0,

              };
              for (let produit of listeProduit) {
                infoFour.produits.push(produit);
                infoFour.mntTotal += parseFloat(produit.mntTotal);
                infoFour.mntTotalHt += parseFloat(produit.mntTotalHt);
              }

                  if(infoFour.produits.length == options.length)
                  {
                    nbCmd++;
                    listeFoun.push(infoFour);
                  }else {
                    nbCmdDeux++;
                    listeFounSecond.push(infoFour);
                  }


            }

            this.nbCommandeSug = nbCmd;
            this.commandeDeriv = listeFoun;
            this.nbCommandeSugDeux = nbCmdDeux;
            this.commandeDerivDeux = listeFounSecond;
            this.dialogDetailCmd = true;
            this.loading = false;
            //AFFICHAGE DE PRODUITS DONT LE MONTANT EST NULL
            if (response.body.listeProdNull.length > 0) {
              this.dialogProdNull = true;
            }

            if (listeFoun.length > 0) {
              this.showModalCompCmd = true;
            }
          }
          this.infOrenseigner = [this.libelle, this.dateLivr,this.priorite,this.projetLib,this.travuxLib,this.chantieretLib,this.idTravaux,this.entrepotLib]
          this.dialogComm = false
          this.showModalCompCmd = true;
        },
        error => {
          this.loading = false;
          this.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
        }
      );
    }
  },

  watch: {
    activDerouler: function(newValue, oldValue) {
      if (newValue) {
        this.showNotification();
        this.loadProjet();
      }
    }
  },

  computed: {},
  mounted() {
    this.loadPage();
    this.loadBonCommande();
    this.loadProjet();
    // this.loadRecentBesoin();
    this.loadDemande();
  }

};

</script>

<style>
.asterix {
  color: red
}
.btnV {
  width: 100%;
  height: 80px;
}

.notification {
  margin-left: 620px;
}
</style>



// WEBPACK FOOTER //
// src/components/besoin/listeDeBci.vue